var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col md:w-full sm:w-auto"},[_c('div',{staticClass:"vx-row md:w-full"})])
}]

export { render, staticRenderFns }